export const NumericView = () => null;
